import { Component } from '@angular/core';
import { Platform, NavController, ModalController, AlertController } from 'ionic-angular';
// import { Subscription } from 'rxjs';
// import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { LoadingPage } from '../loading/loading';
import { HistoryPage } from '../history/history';

import { DataProvider } from '../../providers/data/data';
import { ConstantsProvider } from '../../providers/constants/constants';
import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';
import { HelperProvider } from '../../providers/helper/helper';

import * as $ from 'jquery';

@Component({

   selector: 'page-home',
   templateUrl: 'home.html'
})

export class HomePage {

   private today;
   private queues = [];


   /** ----- Constructor ----- **/

   constructor(private data: DataProvider,
      private constants: ConstantsProvider,
      private cloudData: CloudDataProvider,
      private helper: HelperProvider,
      private platform: Platform,
      private navCtrl: NavController,
      private modalCtrl: ModalController,
      private alertCtrl: AlertController) {

      // get today date
      this.today = new Date();

   }


   /** ----- View LifeCycle ----- **/

   ionViewWillEnter() {

      // refresh data on enter
      this.refreshData();

      let val = this.platform.height();
      console.log('home height: ' + val);
      $('.home-scroll').css('height', (val - 70 - 50) + 'px');
      // console.log( 'check: ' + $( '.home-scroll' ) );
      // $( '.home-scroll' ).each( function( i, obj ) {
      //
      //    console.log( $( obj ) );
      //    $( obj ).css( 'height', ( val - 70 - 50 ) + 'vh' );
      // });

      this.cloudData.get1819rules({}).then(res => {
         // this.constants.dispRestrictionRules = res["rules"];
         console.log(res['rules'])
         this.constants.dispRestrictionRules = res['rules'];
      })
   }


   /** ----- Internal Methods ----- **/

   refreshData() {

      // get today date
      this.today = new Date();
      this.queues = [];
      this.data.standbys = [];
      this.data.pendings = [];
      this.data.actives = [];
      this.data.dones = [];
      this.data.needs = [];
      this.data.dispensings = [];
      this.data.ends = [];


      // show loading indicator and get ticket list
      let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
      loading.present();
      let params = {
         'token': this.data.token,
         'date': this.getApiDate()
         // 'date' : '2021-02-08'
      };

      this.cloudData.getTickets((this.data.isPhy) ? 0 : 1, params).then(res => {

         // dismiss loading indicator and handle response
         loading.dismiss();
         if (res['status'] == true) {
            // save fetched data
            if (this.data.isPhy) {
               this.data.bookings = res['result']['bookings'];
               this.data.checkins = res['result']['checkins'];
               this.data.standbys = res['result']['standby'];
               this.data.pendings = res['result']['pending'];
               this.data.actives = res['result']['active'];
               this.data.dones = res['result']['done'];
               // this.queues = [ this.data.standbys, this.data.pendings, this.data.actives, this.data.ends ];
               this.queues = [this.data.standbys, this.data.pendings, this.data.actives, this.data.dones];
            }
            else {
               // this.constants.bookings = res[ 'result' ][ 'bookings' ];
               this.data.needs = res['result']['need'];
               this.data.dispensings = res['result']['dispensing'];
               this.data.ends = res['result']['end'];
               this.queues = [this.data.needs, this.data.dispensings, this.data.ends];
            }
            this.refreshTempData().then(res => {
               if (!this.data.isPhy) {
                  // this.queues = [ temp1, temp2, temp3 ];
                  let temp1 = [];
                  let temp2 = [];
                  let temp3 = [];
                  for (let i = 0; i < this.queues.length; i++) {
                     for (let j = 0; j < this.queues[i].length; j++) {
                        let ticket = this.queues[i][j];
                        if (!this.checkMed(ticket.pat_row_id.id)) continue;
                        if (ticket.tkt_status == 'pending') temp1.push(ticket);
                        else if (ticket.tkt_status == 'done' && (ticket.is_disping == 0 || ticket.is_disping == 1)) temp2.push(ticket);
                        else if (ticket.tkt_status == 'done' && ticket.is_disping == 2) temp3.push(ticket);
                     }
                  }
                  this.queues = [temp1, temp2, temp3];
               }
            });
         }
         else {
            // show error message
            this.showAlert('讀取失敗', '請稍候再嘗試。', '確認');
         }
      });

   }


   getApiDate() {

      let dateStr = '';
      let monthStr = '' + (this.today.getMonth() + 1);
      if (monthStr.length == 1) monthStr = '0' + monthStr;
      let dayStr = '' + this.today.getDate();
      if (dayStr.length == 1) dayStr = '0' + dayStr;
      dateStr = this.today.getFullYear() + '-' + monthStr + '-' + dayStr;
      return dateStr;

   }


   getTimeDisplay(inGrp, inIdx, ticket) {

      // get ticket id
      try{
         let tktId: number = -1;
         tktId = this.queues[inGrp][inIdx]['tkt_id'];
         // if(this.data.checkins[tktId] == null){
         //    let ticketCheckInTime = this.helper.tConvert( (this.queues[inGrp][inIdx]['tkt_lastmodify']).split(" ")[1] ) ;
         //    let ticketTime = ticketCheckInTime.split(" ")[0].split(":");
         //    ticketTime[0] = ((Number(ticketTime[0]) + 8) % 24);
         //    ticketTime[0] = ticketTime[0] < 10 ? "0" + ticketTime[0].toString() : ticketTime[0].toString();
         //    let ticketTimeDisplayTime = this.helper.tConvert(ticketTime.join(":"));
         //    return ticketTimeDisplayTime;       
         // };
         let checkInTime = (this.data.checkins[tktId] != null) ? this.helper.tConvert( (this.data.checkins[tktId]['checkin_time']).split(" ")[1] ) : ticket.tkt_createtime.split(" ")[1];
         
         let tempTime = checkInTime.split(" ")[0].split(":");
         tempTime[0] = ((Number(tempTime[0]) + 8) % 24);
         tempTime[0] = tempTime[0] < 10 ? "0" + tempTime[0].toString() : tempTime[0].toString();
         let displayTime = this.helper.tConvert(tempTime.join(":"));
         return displayTime;
      }catch{
         return ""
      }

   }


   showAlert(inTitle, inMsg, inConfirm) {

      let alert = this.alertCtrl.create({
         title: inTitle,
         subTitle: inMsg,
         buttons: [inConfirm],
         enableBackdropDismiss: false
      });
      alert.present();

   }


   /** ----- UI Callbacks ----- **/

   onLogoutClicked() {

      let alert = this.alertCtrl.create({
         title: '登出',
         subTitle: '確定要登出嗎？',
         buttons: [
            {
               text: '取消',
               role: 'cancel'
            },
            {
               text: '登出',
               handler: () => {

                  // pop back to previous page
                  this.data.token = '';
                  this.navCtrl.pop();
               }
            }
         ],
         enableBackdropDismiss: false
      });
      alert.present();

   }


   onItemClicked(inGrp, inIdx) {

      // default to History and Consultation step
      this.data.selectedTicket = this.queues[inGrp][inIdx];
      this.data.selectedPatient = this.queues[inGrp][inIdx]['pat_row_id'];
      this.data.activeTab = 1;
      this.data.selectedTicketStatus = this.queues[inGrp][inIdx]['tkt_status']
      // and then push to History

      this.navCtrl.push(HistoryPage);

   }

   refreshTempData() {
      return new Promise((resolve, reject) => {
         let patIds = [];
         for (let i = 0; i < this.queues.length; i++) {
            for (let j = 0; j < this.queues[i].length; j++) {
               //only for standby or done
               if (!this.data.isPhy) {
                  let temp = this.queues[i][j];
                  let patId = temp.pat_row_id.id;
                  patIds.push(patId);
               }
               else if (i == 1 || i == 3) {
                  let temp = this.queues[i][j];
                  let patId = temp.pat_row_id.id;
                  patIds.push(patId);
               }
            }
         }
         let params = {
            'token': this.data.token,
            'patIds': JSON.stringify(patIds)
         };
         let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
         loading.present();

         this.cloudData.getConsultationsByPatids(params).then(res => {
            // dismiss loading indicator and handle response
            loading.dismiss();
            if (res['status'] == true) {
               for (let i = 0; i < res['result']['consultations'].length; i++) {
                  let temp = res['result']['consultations'][i];
                  this.constants.tempData[temp.pat_row_id] = temp.con_dispensary;
               }
               resolve();
            }
            else {
               // show error message
               this.showAlert('讀取失敗', '請稍候再嘗試。', '確認');
            }
         });

      })
   }

   checkMed(inPatId) {
      if (this.constants.tempData[inPatId] != null) {
         let obj = this.constants.tempData[inPatId];
         let parsedObj = JSON.parse(obj);
         for (let i = 0; i < parsedObj.length; i++) {
            for (let j = 0; j < parsedObj[i]['data'].length; j++) {
               if (parsedObj[i]['data'][j]['type'] == 'disp-single' || parsedObj[i]['data'][j]['type'] == 'disp-grouped') {
                  return true;
               }
            }
         }
      }
      return false;
   }

   checkAcu(inPatId) {
      if (this.constants.tempData[inPatId] != null) {
         let obj = this.constants.tempData[inPatId];
         let parsedObj = JSON.parse(obj);
         for (let i = 0; i < parsedObj.length; i++) {
            for (let j = 0; j < parsedObj[i]['data'].length; j++) {
               if (parsedObj[i]['data'][j]['type'] == 'acu-single' || parsedObj[i]['data'][j]['type'] == 'acu-grouped') {
                  return true;
               }
            }
         }
      }
      return false;
   }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts